
import { useState } from 'react';
import { useCart } from '../../hooks/useCart';
import CartDrawer from './CartDrawer';

interface CartButtonProps {
  className?: string;
  isScrolled?: boolean;
}

export default function CartButton({ className = '', isScrolled = true }: CartButtonProps) {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { totalItems } = useCart();

  return (
    <>
      <button
        onClick={() => setIsCartOpen(true)}
        className={`relative w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${className} ${
          isScrolled ? 'hover:bg-gray-100' : 'hover:bg-white/20'
        }`}
      >
        <i className={`ri-shopping-bag-line text-xl ${isScrolled ? 'text-gray-900' : 'text-white'}`} />
        {totalItems > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-amber-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
            {totalItems > 99 ? '99+' : totalItems}
          </span>
        )}
      </button>
      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
}
